import { AXIOS } from "@/AXIOS/http-common";

const state = {
  permissions:[],
};

const actions = {
  
  async getAllUserPermissions(context) {
    return await AXIOS.get("/user/permissions/list").then((response) => {
      //console.log(response);//Для проверки полученных разрешений
      context.commit("setPermissionList", response.data);
    });
  },

  async setPermissionForUser(context,data) {
      return await AXIOS.post( 
        "/admin/user/permissions/set/" + data.userIdOrName,
      {
        permissionName: data.permissionName,
        permissionState: data.permissionState
      });
    },
  async getAllUserPermissionsById(context, userId) {
      return await AXIOS.get("/user/permissions/list/" + userId).then((response) => {
      return response.data;
    });
    },
};

const mutations = {
  setPermissionList(state, data){
    state.permissions = data;
  },
};

const getters = {
  HAS_PERMISSION: (state) => (permissionName) => {
    if (!state.permissions || state.permissions.length === 0) return false;
    return state.permissions.some(p => p === permissionName);
  },
   GET_LISTPERMISSION: (state) => state.permissions,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
